module.exports = __webpack_public_path__ + "static/media/promoImage2x.88dabfc3.png";